import { isEmpty } from 'lodash';
import { ACCOUNT_TYPE, APPLICATION_TYPE } from '../../constants/sessionStorage';
import history from '../../store/utils/history';
import { ACCOUNT_TYPES } from '../constants';
import { applicationTypeStringHelper } from './applicationTypeStringHelper';
import { storeInSessionStorage } from './sessionStorageHelper';

export const applicationStepRedirectionHelper = (Application) => {
  if (!isEmpty(Application)) {
    const { ApplicationStep, ApplicationType } = Application;

    if (ApplicationStep) {
      if (ApplicationType) {
        const applicationTypeString = applicationTypeStringHelper(
          ApplicationType,
        );

        storeInSessionStorage(APPLICATION_TYPE, applicationTypeString);

        const accountData = Application[applicationTypeString];

        if (accountData && applicationTypeString && accountData?.AccountType) {
          const accountTypeString =
            ACCOUNT_TYPES[applicationTypeString][accountData?.AccountType];

          if (accountTypeString) {
            storeInSessionStorage(ACCOUNT_TYPE, accountTypeString);
          }
        }
      }

      history.push(ApplicationStep);
      return true;
    }
  }

  return false;
};
